<template>
  <section
    v-if="datosConvocatorias"
    id="convocatorias"
    class="left-image-wrap p-t-b-80 light-gray"
  >
    <b-container>
      <b-row>
        <b-col
          md="12"
          class="section-header mb-3"
        >
          <h2 class="titulosAzul">
            Convocatorias
          </h2>
        </b-col>
        <b-col cols="12">
          <convocatoria
            v-for="(convocatoria, index) in datosConvocatorias"
            :key="index"
            :datos="convocatoria"
          />
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
import {
  BCol, BContainer, BRow, VBToggle,
} from 'bootstrap-vue'

import Convocatoria from './components/Convocatoria2.vue'

export default {
  directives: {
    'b-toggle': VBToggle,
  },
  components: {
    Convocatoria,
    BCol,
    BContainer,
    BRow,
    // BOverlay,
  },
  props: {
    datosConvocatorias: {
      type: Array,
      default: null,
    },
  },
  methods: {
    goRegistro() {
      const vm = this
      vm.$router.push({ name: 'registro' })
    },
  },
}
</script>
<style>
.btn-card {
  font-size: 15px;
}
.btn-registro {
  font-size: 20px;
}
</style>
